const mountDpoSteps = (governanceProjectTemplate) => [
  {
    title: governanceProjectTemplate?.name,
    subtitle:
      'Informe o CNPJ da sua organização para iniciar a nomeação do Encarregado de Dados (DPO) e Substituto.',
    description: governanceProjectTemplate?.description,
  },
  {
    title: 'Nomeação do Encarregado',
    subtitle:
      'O Encarregado de Dados (DPO) da sua organização é um colaborador interno (vinculado a um departamento) ou foi contratado como prestador de serviço externo?',
    description:
      'Nesta etapa, você deve informar os dados do Encarregado de Dados (DPO), responsável pela proteção de dados pessoais da sua organização.',
  },
  {
    title: 'Nomeação do Substituto',
    subtitle:
      'Informe os dados do substituto do DPO. Ele deve ser um colaborador interno, vinculado a algum departamento da sua organização — não sendo permitida a indicação de profissionais terceirizados.',
    description:
      'Nesta etapa, você deve informar os dados do Substituto do seui Encarregado de Dados (DPO). Ele deve ser um colaborador interno da organização.',
  },
  {
    title: 'Ficha de Indicação',
    subtitle:
      'Informe a Diretoria Executiva, depois baixe o modelo, preencha os dados, colete as assinaturas e anexo o documento para formalizar as nomeações.',
    description:
      'Nesta etapa, é necessário anexar a Ficha de Indicação que formaliza a nomeação do DPO e de seu substituto. Baixe o modelo disponível, preencha com as informações necessárias, colete as assinaturas e envie o documento assinado pela plataforma.',
  },
  {
    title: 'Nomeação enviada com sucesso',
    subtitle:
      'A sua nomeação foi registrada e será analisada pela equipe do Programa. Você receberá a confirmação da submissão e demais atualizações por e-mail.',
    description:
      'A sua nomeação foi registrada e será analisada pela equipe do Programa. Acompanhe o status por este link ou aguarde as atualizações por e-mail.',
  },
]

export default mountDpoSteps
